/**
 * Permissões da ferramenta de modelos de modalidades (`/sie/modalidades`).
 *
 * Os números já existiam em produção, sem uso no código (criados em 24/05/2026):
 * 2210 "Modalidades gerenciamento : Visualizar" e 2212 "... : Atualizar".
 * Criar/Excluir/Ativar (2211/2213/2214) não se aplicam: os modelos têm ids fixos
 * e nunca são apagados.
 */
export const MODALIDADES_VISUALIZAR_REGRA = 2210;
export const MODALIDADES_ATUALIZAR_REGRA = 2212;

/** Quem entra na rota: qualquer uma das duas (quem atualiza também precisa ver). */
export const MODALIDADES_ACESSO = [MODALIDADES_VISUALIZAR_REGRA, MODALIDADES_ATUALIZAR_REGRA];

/** Compara sem depender do tipo: `rulesOwned` mistura número e string. */
export function possuiPermissao(currentUser, permissao) {
  const owned = currentUser?.rulesOwned || [];
  const aceitas = Array.isArray(permissao) ? permissao : [permissao];
  return owned.some((p) => aceitas.some((req) => Number(p) === Number(req)));
}
